import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('mpg_cookies_accepted');
    
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('mpg_cookies_accepted', 'true');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('mpg_cookies_accepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>
            {isGerman 
              ? '🍪 Wir verwenden Cookies' 
              : '🍪 We use Cookies'
            }
          </h3>
          <p>
            {isGerman
              ? 'Diese Website verwendet Cookies, um Ihre Benutzererfahrung zu verbessern und die Funktionalität der Website zu gewährleisten. Durch die Nutzung dieser Website stimmen Sie der Verwendung von Cookies zu.'
              : 'This website uses cookies to improve your user experience and ensure the functionality of the website. By using this website, you agree to the use of cookies.'
            }
          </p>
        </div>
        <div className="cookie-actions">
          <button onClick={declineCookies} className="cookie-button decline">
            {isGerman ? 'Ablehnen' : 'Decline'}
          </button>
          <button onClick={acceptCookies} className="cookie-button accept" data-testid="accept-cookies">
            {isGerman ? 'Akzeptieren' : 'Accept'}
          </button>
        </div>
      </div>
    </div>
  );
};
